import Vue from 'vue'

const bus = new Vue()

export default function(ctx, inject) {
  inject('bus', bus)
}
